import { useContext } from "react";
import { AppContext } from "../context/AppContext";
import Height from "./Properties/Height";
import Name from "./Properties/Name";
import Width from "./Properties/Width";
import Fill from "./Properties/Fill";
import Angle from "./Properties/Angle";
import Left from "./Properties/Left";
import Top from "./Properties/Top";
import PropertiesEmpty from "./PropertiesEmpty";
import ClipPath from "./Properties/ClipPath";
import Opacity from "./Properties/Opacity";
import PropertyLabel from "./Properties/shared/PropertyLabel";
import TextBackgroundColor from "./Properties/TextBackgroundColor";
import Font from "./Properties/Font";
import Shadow from "./Properties/Shadow";
import Stroke from "./Properties/Stroke";
import BorderRadius from "./Properties/BorderRadius";
import Qrcode from "./Properties/Qrcode";
import WidthHeightProportionalScale from "./Properties/WidthHeightProportionalScale";
import { useTranslation } from "react-i18next";
import ImageFit from "./Properties/ImageFit";

function doesExist(value: unknown): boolean {
  return value !== undefined && value !== null;
}

function Properties() {
  const { selectedObject } = useContext(AppContext);
  const { t } = useTranslation();
  return (
    <div className="h-full overflow-auto border-l border-gray-200 bg-gray-50 p-6">
      {!selectedObject && (
        <div className="flex h-full items-center justify-center">
          <PropertiesEmpty />
        </div>
      )}
      {selectedObject && (
        <div className="space-y-4">
          {doesExist(selectedObject?.get("name")) && (
            <div>
              <PropertyLabel>{t("properties_name")}</PropertyLabel>
              <Name />
            </div>
          )}
          {doesExist(selectedObject?.get("width")) &&
            doesExist(selectedObject?.get("height")) && (
              <div className="grid grid-cols-5 gap-2">
                <div className="col-span-2">
                  <PropertyLabel>{t("properties_width")}</PropertyLabel>
                  <Width />
                </div>
                <div className="col-span-2">
                  <PropertyLabel>{t("properties_height")}</PropertyLabel>
                  <Height />
                </div>
                <div className="col-span-1 text-center">
                  <PropertyLabel>{t("properties_ratio")}</PropertyLabel>
                  <WidthHeightProportionalScale />
                </div>
              </div>
            )}
          <div className="grid grid-cols-2 gap-4">
            <div>
              {doesExist(selectedObject?.get("left")) && (
                <div>
                  <PropertyLabel>{t("properties_left")}</PropertyLabel>
                  <Left />
                </div>
              )}
            </div>
            <div>
              {doesExist(selectedObject?.get("top")) && (
                <div>
                  <PropertyLabel>{t("properties_top")}</PropertyLabel>
                  <Top />
                </div>
              )}
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              {doesExist(selectedObject?.get("angle")) && (
                <div>
                  <PropertyLabel>{t("properties_angle")}</PropertyLabel>
                  <Angle />
                </div>
              )}
            </div>
            <div>
              {doesExist(selectedObject?.get("opacity")) && (
                <div>
                  <PropertyLabel>{t("properties_opacity")}</PropertyLabel>
                  <Opacity />
                </div>
              )}
            </div>
          </div>
          {doesExist(selectedObject?.get("fill")) && (
            <div>
              <PropertyLabel>{t("properties_fill")}</PropertyLabel>
              <Fill />
            </div>
          )}
          {selectedObject.type === "qrcode" && (
            <div>
              <PropertyLabel>{t("properties_content")}</PropertyLabel>
              <Qrcode />
            </div>
          )}
          {selectedObject.type === "textbox" && (
            <div>
              <Font />
            </div>
          )}
          {selectedObject.type === "textbox" && (
            <div>
              <PropertyLabel>{t("properties_text_background_color")}</PropertyLabel>
              <TextBackgroundColor />
            </div>
          )}
          {selectedObject.type === "rect" && (
            <div>
              <PropertyLabel>{t("properties_border_radius")}</PropertyLabel>
              <BorderRadius />
            </div>
          )}
          <div>
            <PropertyLabel>{t("properties_stroke")}</PropertyLabel>
            <Stroke />
          </div>
          {/* the default shadow value is null */}
          <div>
            <PropertyLabel>{t("properties_shadow")}</PropertyLabel>
            <Shadow />
          </div>
          {selectedObject.type === "image" && (
            <div>
              <PropertyLabel>{t("properties_image_fit")}</PropertyLabel>
              <ImageFit />
            </div>
          )}
          {selectedObject.type === "image" && (
            <div>
              <h2>{t("properties_image_clippaths")}</h2>
              <ClipPath />
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default Properties;
